import star from "@/public/icons/star.svg";
import skills from "@/public/icons/skills.svg";
import questions from "@/public/icons/questions.svg";
import briefcase from "@/public/icons/briefcase.svg";
import team from "@/public/icons/team.svg";
import training from "@/public/icons/training.svg";
import email from "@/public/icons/email.svg";
import job from "@/public/icons/job.svg";
import user from "@/public/icons/unknown-user.svg";
import clients from "@/public/icons/clients.svg";

export const icons = {
  star,
  skills,
  questions,
  briefcase,
  team,
  training,
  clients,
  email,
  job,
  user,
};
